import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import ProjectPopup from './ProjectPopup';
import * as actions from '../../redux/actions';

// หน้าต่างแยกจริง (window.open จาก ProjectList.js) แทนที่ popup modal เดิม — ไม่มี
// sidebar/navbar ครอบ (route นี้อยู่นอก layout Project() ตั้งใจ) เนื้อหาเป็น ProjectPopup
// ตัวเดิมเป๊ะ (ทั้ง 2 แท็บ แดชบอร์ด/รายละเอียด) แค่เปลี่ยนที่ครอบจาก Dialog เป็นทั้งหน้าต่าง
export default function ProjectPopupWindow() {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [navIds, setNavIds] = useState([]);
  const [filterChips, setFilterChips] = useState([]);
  // อยู่นอก ProjectPopup ตั้งใจ — popup ใช้ key={id} ทำให้ remount ใหม่ทั้งก้อนทุกครั้งที่เลื่อน
  // ก่อนหน้า/ถัดไป (เปลี่ยน route) ถ้าเก็บ sheet ไว้ข้างในจะรีเซ็ตกลับแท็บแรกทุกครั้ง
  const [sheet, setSheet] = useState(0);

  useEffect(() => {
    dispatch(actions.meGet());
  }, [dispatch]);

  // ขอลิสต์ id ตามลำดับที่กรอง/เรียงอยู่ใน P5 ตอนเปิดหน้าต่างนี้ จาก parent tab (window.opener)
  // เพื่อทำปุ่มเลื่อนถัดไป/ก่อนหน้า — ถ้า parent tab ถูกปิดไปแล้วก็แค่ไม่มีปุ่มนี้ให้ใช้
  useEffect(() => {
    if (!window.opener || window.opener.closed) return undefined;
    const handler = (e) => {
      if (e.origin !== window.location.origin) return;
      if (e.data?.type === 'nav-list') {
        setNavIds(e.data.ids || []);
        setFilterChips(e.data.filterChips || []);
      }
    };
    window.addEventListener('message', handler);
    window.opener.postMessage({ type: 'request-nav-list' }, window.location.origin);
    return () => window.removeEventListener('message', handler);
  }, []);

  const navIndex = navIds.indexOf(id);

  const notifyOpener = (type, extra) => {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        { type, id, ...extra },
        window.location.origin,
      );
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.paper' }}>
      <ProjectPopup
        key={id}
        propId={id}
        onClose={() => window.close()}
        onSaved={() => notifyOpener('project-saved')}
        onPopIn={() => {
          notifyOpener('pop-in');
          window.close();
        }}
        onPrev={
          navIndex > 0
            ? () => history.push(`/project-popup/${navIds[navIndex - 1]}`)
            : undefined
        }
        onNext={
          navIndex >= 0 && navIndex < navIds.length - 1
            ? () => history.push(`/project-popup/${navIds[navIndex + 1]}`)
            : undefined
        }
        navIndex={navIndex}
        navTotal={navIds.length}
        filterChips={filterChips}
        initialData={null}
        sheet={sheet}
        onSheetChange={setSheet}
      />
    </Box>
  );
}
